import { DivisionListFilter } from './components/divisions-list-filter';
import { DivisionsListTable } from './components/divisions-list-table';
import { ContextMenu } from '~/components/ContextMenu/ContextMenu';
import { PageLayout } from '~/components/PageLayout/PageLayout';
import { Pagination } from '~/components/Pagination/Pagination';
import { useFilterForm } from '~/hooks/useFilterForm';
import { useDivisionListQuery } from '../queries';
import { Fragment } from 'react/jsx-runtime';
import { querySchema } from './query-schema';
import { insertOnCondition } from '~/utils/array';
import { useAuthentication } from '~/hooks/useAuthentication';

export function Page() {
  const { values } = useFilterForm(querySchema.parse);
  const { can } = useAuthentication();

  const { data, isLoading } = useDivisionListQuery({
    page_size: values.pageSize,
    ordering: values.ordering,
    page: values.pageIndex,
    search: values.search,
    year: values.year,
  });

  return (
    <Fragment>
      <PageLayout.Header>
        <PageLayout.Heading text="Serieresultat" />

        <PageLayout.Context
          items={[
            ...insertOnCondition(
              <ContextMenu.Item label="Skapa division" to="create" key="create" />,
              can('create-division')
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Hantera serier" to="/series" key="series" />,
              can('manage-series')
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Hantera serieomgångar" to="/series/rounds" key="rounds" />,
              can('manage-round')
            ),
            ...insertOnCondition(
              <ContextMenu.Item label="Hantera lag" to="/series/teams" key="teams" />,
              can('manage-team')
            ),
          ]}
        />
      </PageLayout.Header>

      <PageLayout.Section>
        <DivisionListFilter />
        <DivisionsListTable divisions={data?.results ?? []} isLoading={isLoading} />
        <Pagination count={data?.count} />
      </PageLayout.Section>
    </Fragment>
  );
}
